<template>
    <div class="request-a-visit-area ptb-100">
        <div class="container">
            <div class="request-a-visit-form">
                <span class="sub-title">Visit Apartment</span>
                <h2>Request a visit</h2>
                <form @submit.prevent>
                    <div class="form-group">
                        <input type="text" placeholder="Full Name">
                    </div>
                    <div class="form-group">
                        <input type="email" placeholder="Enter you emaill address">
                    </div>
                    <div class="form-group">
                        <input type="text" placeholder="MM / DD / YY">
                    </div>
                    <div class="form-group">
                        <select class="form-select">
                            <option selected>Time</option>
                            <option value="1">10:00AM - 06:00PM</option>
                            <option value="2">12:00AM - 06:00PM</option>
                            <option value="3">11:00AM - 06:00PM</option>
                            <option value="3">02:00AM - 06:00PM</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <textarea cols="30" rows="4" placeholder="Your Message"></textarea>
                    </div>
                    <button type="submit" class="btn-style-one red-light-color">
                        Submit Now 
                        <i class="ph-caret-right"></i>
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VisitApartment'
}
</script>